import stack from '../StackedBarChart/stack'

export default function(props) {
  // polyfill for old browsers
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/flat
  if (!Array.prototype.flat) {
    // eslint-disable-next-line no-extend-native
    Array.prototype.flat = function() {
      var depth = arguments[0]
      depth = depth === undefined ? 1 : Math.floor(depth)
      if (depth < 1) return Array.prototype.slice.call(this)
      return (function flat(arr, depth) {
        var len = arr.length >>> 0
        var flattened = []
        var i = 0
        while (i < len) {
          if (i in arr) {
            var el = arr[i]
            if (Array.isArray(el) && depth > 0)
              flattened = flattened.concat(flat(el, depth - 1))
            else flattened.push(el)
          }
          i++
        }
        return flattened
      })(this, depth)
    }
  }

  const {
    data,
    costBurdenThreshold,
    costBurdenKey,
    place,
    placeKey,
    xKey,
    tenure,
    costBurdenBinKey,
    valueKey,
    tenureKey,
    amiMethod,
    amiMethodKey,
    amiBinSortOrder,
    amiBinKey
  } = props

  const flatData = data || []

  // console.log('flatData from filterData', flatData)

  const belowPattern = /0-.*/
  const abovePattern = /Over.*/i

  flatData.forEach(d => {
    const costBurdenBin = d[costBurdenBinKey]
    // // console.log('costBurdenBin', costBurdenBin)

    // if we are below the threshold
    if (belowPattern.test(costBurdenBin)) {
      d.position = 'below'
    } else if (abovePattern.test(costBurdenBin)) {
      d.position = 'above'
    } else {
      console.error('costBurdenBin malformed for this record', d)
    }
  })

  const filteredData = flatData.filter(d => {
    // console.log(
    //   `${d[placeKey]}, ${place} | ${d[tenureKey]}, ${tenure} | ${d[costBurdenKey]}, ${costBurdenThreshold}`
    // )
    // console.log(`${d[amiMethodKey]} | ${amiMethod}`)

    return (
      d[placeKey] === place &&
      d[tenureKey] === tenure &&
      d[amiMethodKey] === amiMethod &&
      Number(d[costBurdenKey]) === Number(costBurdenThreshold)
    )
  })

  // console.log('filteredData', filteredData)

  const formattedData = filteredData.map(d => {
    d.amiMethodLabel = `${d[amiMethodKey]}`
    return d
  })

  const keys = ['position', xKey]
  // console.log('keys', keys)
  // console.log('data', data)

  const stackedData = stack({ data: formattedData, keys, valueKey })
  const sortedStackedData = stackedData
    .sort((a, b) => {
      // console.log('a', a)
      // console.log('b', b)
      return a.position.localeCompare(b.position)
    })
    .sort((a, b) => {
      // console.log('a', a)
      // console.log('b', b)
      // console.log('amiBinKey', amiBinKey)
      // console.log(`${a[amiBinKey]} ${b[amiBinKey]}`)
      return amiBinSortOrder[a[amiBinKey]] - amiBinSortOrder[b[amiBinKey]]
    })
  // console.log('stackedData', stackedData)
  // console.log('sortedStackedData', sortedStackedData)

  return sortedStackedData
}
